// import { homeMenu } from './home';
import { MenuItem } from '../../../commons/ui/menu';
import { promotionsMenu } from './promotions';

export const routes: MenuItem[] = [
  // homeMenu,
  promotionsMenu,
];
